import lazy from 'utils/lazy';

export const Registration = lazy(() => import('./Registration'));
